//import 'office-ui-fabric-react/dist/css/fabric.css';
import * as microsoftTeams from "@microsoft/teams-js";
import { useState } from "react";
import { BrowserView, MobileView, isMobile } from 'react-device-detect';
import * as rdd from 'react-device-detect';

export default function Config() {

console.log("RENATO TEST ISMOBILE: " + isMobile);
const [mylog, setmylog] = useState<string>("mylog");
var myMobile = false;

  return (
    
    <div>
      <BrowserView>
      {/* <Image style={{ height: '43px', width: '31px', marginBottom: '10px' }} src={"cube.png"} /> */}
      <h3>Get started with BitFractal for Teams</h3> <br />
      <h3>{mylog}</h3>
      <h3>Browser {rdd.browserName} OS {rdd.osName}  isMobile {isMobile ? "true" : "false"}</h3>
      <label>1. Create voice clips using AI</label><br />
      <label>2. Collaborate while you build your voice projects </label><br />
      <label>3. Easiy export results to an audio file</label><br />
      <button onClick={() => {setmylog("RENATO");}}>CLICK HERE</button>
      {/* <button className='bitbutton' onClick={() => { microsoftTeams.settings.setValidityState(true); saveconfig(); }}>Add BitFractal</button> */}
      </BrowserView>
      <MobileView>
        <h3>THIS IS A MOBILE VIEW/h3</h3> <br />
        <h3>Browser {rdd.browserName} OS {rdd.osName}  isMobile {isMobile ? "true" : "false"}</h3>
      </MobileView>
    </div>
  );
}